module.exports = __webpack_public_path__ + "img/course_img_1.4b8bf6ed.png";